import {
    CTRL_COMMUNITY_LIST,
    CTRL_CREATE_COMMUNITY,
    CTRL_EDIT_COMMUNITY,
    CTRL_GET_COMMUNITY,
    CTRL_GET_COMMUNITY_DETAILS,
    CTRL_DELETE_COMMUNITY,
} from '../../index.types';


/* =========================
   GET COMMUNITY LIST
========================= */
export function getCommunities(data) {
    return {
        type: CTRL_COMMUNITY_LIST,
        data
    };
}

/* =========================
   CREATE COMMUNITY
========================= */
export function createCommunity(data) {
    return {
        type: CTRL_CREATE_COMMUNITY,
        data
    };
}

/* =========================
   EDIT COMMUNITY
========================= */
export function editCommunity(data) {
    return {
        type: CTRL_EDIT_COMMUNITY,
        data
    };
}


/* =========================
   GET COMMUNITY
========================= */
export function getCommunity(data) {
    return {
        type: CTRL_GET_COMMUNITY,
        data
    };
}


/* =========================
   GET COMMUNITY DETAILS
========================= */
export function getCommunityDetails(data) {
    return {
        type: CTRL_GET_COMMUNITY_DETAILS,
        data
    };
}

/* =========================
   DELETE COMMUNITY
========================= */
export function deleteCommunity(data) {
    return {
        type: CTRL_DELETE_COMMUNITY,
        data
    };
}

